export default function Step2() {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.3333 6.56836H8.66667C7.19391 6.56836 6 7.76227 6 9.23503V27.9017C6 29.3745 7.19391 30.5684 8.66667 30.5684H27.3333C28.8061 30.5684 30 29.3745 30 27.9017V9.23503C30 7.76227 28.8061 6.56836 27.3333 6.56836Z"
                stroke="#3F68E0"
                strokeWidth="1.134"
            />
            <path
                d="M17.9993 19.235C19.8403 19.235 21.3327 17.7426 21.3327 15.9017C21.3327 14.0607 19.8403 12.5684 17.9993 12.5684C16.1584 12.5684 14.666 14.0607 14.666 15.9017C14.666 17.7426 16.1584 19.235 17.9993 19.235Z"
                stroke="#3F68E0"
                strokeWidth="1.134"
            />
            <path
                d="M24 25.9014C24 22.5877 21.3137 19.9014 18 19.9014C14.6863 19.9014 12 22.5877 12 25.9014"
                stroke="#3F68E0"
                strokeWidth="1.134"
                strokeLinecap="round"
            />
        </svg>
    );
}
